// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"398":"fcb22f25","399":"1836c712","923":"064269ee","927":"1fc31f30"}[chunkId] + ".chunk.js";
};